import * as React from 'react';
import { BanksListContainer } from '../../containers/BanksListContainer';
import { SubmitPhoneFormContainer } from '../../containers/SubmitPhoneFormContainer';
import { SuburbanFinCalculatorContainer } from '../../containers/SuburbanFinCalculatorContainer';
import { SuburbanMortgageProgramsContainer } from '../../containers/SuburbanMortgageProgramsContainer';
import { SuburbanShowcaseContainer } from '../../containers/SuburbanShowcaseContainer/SuburbanShowcaseContainer';
import { SuburbanMortgageBannerContainer } from '../../containers/SuburbanMortgageBannerContainer';
import { SupportBlock } from '../../SuburbanComponents/SupportBlock';

export const SuburbanPage = () => {
  return (
    <>
      <SubmitPhoneFormContainer Form={SuburbanShowcaseContainer} label="main_login_block" />
      <SuburbanMortgageProgramsContainer />
      <SuburbanMortgageBannerContainer />
      <BanksListContainer />
      <SuburbanFinCalculatorContainer />
      <SupportBlock />
    </>
  );
};
